export default __webpack_public_path__ + "static/media/by.de348768.svg";